<template>
  <div class='field-container user-input-list'
       :class="{ 'searching-user': dropdownOpen }">
    <label :class="model ? 'fc-blue-8' : 'fc-blue-4'">{{ label }}:</label>
    <div class='field'>
      <sword-text-wuk v-if='isEditable && !selectedSuggestion'
                      :name='name'
                      v-model='model'
                      class='user-input-list__search-input'
                      autocomplete='off'
                      :validation='validation'
                      :manual-error='manualFeedback'
                      @click.native='openSuggestions'
                      @blur='resetSuggestions'>
      </sword-text-wuk>
      <div class='patient-badge t4' v-if='selectedSuggestion'>
        <profile-picture  side='1.9rem'
                          :vip="selectedSuggestion.vip"
                          :high-risk="selectedSuggestion.highRisk"
                          :picture='selectedSuggestion.picture'
                          :gender='selectedSuggestion.gender'>
        </profile-picture>
        <span class='name fc-blue-8'>{{ selectedSuggestion.name }}</span>
        <button v-if='isEditable' @click='clearField'>
          <sword-icon-wuk name='close'></sword-icon-wuk>
        </button>
      </div>
    </div>
    <div class='fc-blue-4'>
      <div  class='search-dropdown'
            v-if='isEditable && dropdownOpen && suggestions && suggestions.length'>
        <ul class='search-dropdown-list'>
          <li v-for='(suggestion, key) of suggestions'
              :key='key'
              class='search-dropdown-item'
              @mousedown='selectSuggestion(suggestion)'>
            <profile-picture  side='1.6rem'
                              :vip="suggestion.is_vip_account"
                              :high-risk="!!suggestion.patient_is_high_risk"
                              :picture='suggestion.picture'
                              :gender='suggestion.gender'>
            </profile-picture>
            <span class='name fc-blue-8'>{{ suggestion.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SwordTextWuk from '@ui-kit/components/inputs/SwordText.vue';
import ProfilePicture from '@ui-kit/components/pictures/ProfilePicture.vue';
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'userInputList',
  components: {
    ProfilePicture,
    SwordTextWuk,
    SwordIconWuk,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default: () => {},
    },
    defaultSuggestion: {
      type: null,
      default: null,
    },
    suggestions: {
      type: Array,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dropdownOpen: '',
      selectedSuggestion: this.defaultSuggestion,
      manualFeedback: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.validateUser();
        this.resetFormFeedback();
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    !!this.defaultSuggestion && this.selectSuggestion(this.defaultSuggestion);
  },
  methods: {
    clearField() {
      this.model = '';
      this.selectedSuggestion = null;
      this.$emit('selected-suggestion', null);
    },
    openSuggestions(event) {
      event.target.focus();
      this.openDropdown();
    },
    selectSuggestion(suggestion) {
      this.model = suggestion.name;
      this.selectedSuggestion = suggestion;
      this.closeDropdown();
      this.$emit('selected-suggestion', this.selectedSuggestion);
    },
    validateUser() {
      if (!this.selectedSuggestion && this.model) {
        this.manualFeedback = this.$t('copy_2058');
        return false;
      }

      return true;
    },
    openDropdown() {
      this.dropdownOpen = true;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    resetFormFeedback() {
      this.manualFeedback = '';
    },
    resetSuggestions() {
      this.$emit('reset-suggestions');
    }
  },
};
</script>

<style lang='scss' scoped>

.user-input-list {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 2.7rem;

  &.field-container {
    padding-bottom: 0.2rem;
  }

  &__search-input {
    z-index: 1;
    background-color: transparent;
  }

  label {
    flex: 0;
    line-height: 1.5;
    margin-right: 0.625rem;
  }

  .field {
    flex: 1;
    position: relative;

    input {
      position: inherit;
      z-index: 9;
    }
  }
}

.search-dropdown {
  border-radius: 0.3rem;
  position: absolute;
  top: 3rem;
  left: 0;
  z-index: 1;
  width: 100%;

  &::before,
  &::after {
    content: '';
    border-style: solid;
    border-width: 0 7px 7px 7px;
    position: absolute;
    left: 2.5rem;
    width: 0;
    height: 0;
  }

  &::before {
    top: -0.5rem;
    border-color: transparent transparent $context-color-7 transparent;
  }

  &::after {
    top: -6px;
    border-color: transparent transparent #ffffff transparent;
  }
}

.search-dropdown,
.patient-badge {
  border: 1px solid $context-color-7;
}

.patient-badge {
  background-color: #f8f9fa;
  border-radius: 1.25rem;
  padding: 0.25rem;
  display: inline-flex;
  align-items: center;

  .name,
  .clear {
    display: inherit;
    vertical-align: middle;
  }

  .name {
    flex-grow: 1;
    margin-left: 0.625rem;
  }

  .clear {
    padding: 0.5rem;
    cursor: pointer;
    flex-grow: 0;
    justify-self: flex-end;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
  }

  .svg-icon {
    width: 0.7rem;
    margin: 0 0.5rem;
  }
}

.search-dropdown-list {
  background-color: white;
  max-height: 15.5rem;
  overflow-y: auto;

  li.search-dropdown-item {
    padding: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;

    .name {
      margin-left: 0.25em;
      display: inline-block;
      margin-top: 0.25rem;
      line-height: 1.3rem;
      vertical-align: middle;
    }

    &:hover {
      cursor: pointer;
      background-color: $context-color-8;
    }
  }
}
</style>
